import { encryptionAES, sha256WithRSA, uuid } from '@h5-journey/utils'

export const ENCRYPT_WHITELIST: (string | RegExp)[] = ['/stat/mark']

// 根据url校验是否需要进行加密
export function shouldEncrypt(url?: string) {
  if (!url || !Array.isArray(ENCRYPT_WHITELIST) || ENCRYPT_WHITELIST.length === 0) {
    return false // 默认不需要加密
  }

  return ENCRYPT_WHITELIST.some((pattern) => {
    if (typeof pattern === 'string') {
      // 字符串匹配：完全匹配或路径包含
      return url === pattern || url.includes(pattern)
    } else if (pattern instanceof RegExp) {
      // 正则表达式匹配
      return pattern.test(url)
    }
    return false
  })
}

// 数据加密
export const encryptData = (url: string, data: Record<string, any>) => {
  const isThirdApi = ~url.indexOf('http') //请求地址http开头的第三方接口
  // const enableEncrypt = shouldEncrypt(url)

  // 非第三方api加密
  if (isThirdApi) {
    return data
  }
  // 生成请求参数
  const requestUuid = uuid() // 重命名变量避免冲突
  const timestamp = new Date().getTime().toString()
  const version = '1.0'
  const systemId = '2201'
  // 只加密 body 内容
  const encryptedBody = encryptionAES(data)
  // 生成签名
  const signStr = sha256WithRSA({
    systemId,
    uuid: requestUuid,
    timestamp,
    versionId: version
  })

  // 构造新的请求体
  return {
    systemId,
    sign: signStr,
    uuid: requestUuid,
    timestamp,
    version,
    body: encryptedBody
  }
}
